import { createBrowserRouter } from 'react-router-dom';

import getRoutes from 'routes';

import { RouteWithChildren } from 'types/route';

import NotFoundPage from '../pages/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute';

export const createAppRouter = () => {
  return createBrowserRouter([
    ...getRoutes().map((route: RouteWithChildren) => ({
      ...route,
      element: route.protectedRoute ? (
        <ProtectedRoute module={route.module}>{route.element}</ProtectedRoute>
      ) : (
        route.element
      ),
      children: route.children
        ? route.children.map((child: RouteWithChildren) => ({
            ...child,
            element: child.protectedRoute ? (
              <ProtectedRoute module={child.module}>
                {child.element}
              </ProtectedRoute>
            ) : (
              child.element
            )
          }))
        : []
    })),
    {
      path: '*',
      key: 'NOT_FOUND',
      element: <NotFoundPage />
    }
  ]);
};
